import { DirectUpload } from '@rails/activestorage';
import { post } from '@rails/request.js';
import type { Editor } from '@tiptap/core';

export const ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif'];

export interface UploadResult {
  url: string;
}

export interface UploadDelegate {
  directUploadWillStoreFileWithXHR?: (xhr: XMLHttpRequest) => void;
}

export function createUploadFile(directUploadUrl: string, attachmentsUrl: string) {
  return (file: File, delegate: UploadDelegate): Promise<UploadResult> => {
    return new Promise((resolve, reject) => {
      const upload = new DirectUpload(file, directUploadUrl, delegate);
      upload.create(async (error, blob) => {
        if (error) {
          reject(error);
        } else {
          const response = await post(attachmentsUrl, {
            responseKind: 'json',
            body: {
              attachment: {
                file: blob.signed_id,
              },
            },
          });

          if (response.ok) {
            const json = await response.json;
            resolve(json as UploadResult);
          } else {
            const json = await response.json;
            reject(new Error((json as { error: string }).error));
          }
        }
      });
    });
  };
}

export function handleImagePaste(editor: Editor, files: File[], htmlContent?: string): void {
  if (htmlContent && htmlContent.length > 0) return;

  files.forEach((file) => {
    editor.chain().focus().startImageUpload(file).run();
  });
}

export function handleImageDrop(editor: Editor, files: File[], pos: number): void {
  files.forEach((file) => {
    editor.chain().focus().startImageUpload(file).run();
  });
}
